import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  menuList: {
    width: 300,
  },
  menuItemText: {
    fontWeight: 500,
  },
});

export default useStyles;
